// Mock data
import Fetch from "../../fetch";
import users from "data/users";
import orders from "data/orders";
import FetchAuth from "../../fetch/auth";

const token = () => "Bearer " + localStorage.getItem("token");

export const signIn = async ({ email, password, captcha }) => {
  const token = "Basic " + btoa(`${email}:${password}`);
  return await Fetch({
    auth: token,
    api: "auth/admin",
    type: "POST",
    body: JSON.stringify({ captcha })
  });
};

export const getUsersChatList = async () => {
  return await Fetch({
    api: "users/chat-list",
    type: "GET",
    auth: token()
  });
};

export const getUser = async token => {
  return await Fetch({
    auth: `Bearer ${token}`,
    body: null,
    type: "GET",
    api: "/users/self"
  });
};

export const changeUserCulture = async ({ token, id, name, mobile }) => {
  let body;
  if (mobile !== null) {
    body = {
      query: `
      mutation{
        updateUser(
          culture:"${id}"
          id: "me"
          name: "${name}"
          mobile:"${mobile}"
          ){
          culture{
          id
          language
        }
        }
      }
      `
    };
  } else {
    body = {
      query: `
      mutation{
        updateUser(
          culture:"${id}"
          id: "me"
          name: "${name}"
          mobile:""
          ){
          culture{
          id
          language
          direction
        }
        }
      }
      `
    };
  }

  return await FetchAuth({
    auth: `Bearer ${token}`,
    body: JSON.stringify(body)
  });
};

export const getUsers = (limit = 10) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const usersLookup = users.slice(0, limit).map(lookupUser);

      resolve({
        users: usersLookup,
        usersTotal: users.length
      });
    }, 700);
  });
};

function lookupUser(user) {
  const userCopy = JSON.parse(JSON.stringify(user));
  const userOrders = userCopy.orders.map(id =>
    orders.find(order => order.id === id)
  );
  const userMoneySpent = userCopy.orders.reduce(
    (total, order) => total + order.amount,
    0
  );

  userCopy.orders = userOrders;
  userCopy.moneySpent = userMoneySpent;

  return userCopy;
}
